module.exports = __webpack_public_path__ + "static/media/mini-kit.5101fd19.png";